import { __assign } from "tslib";
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { rgbaArray2rgba } from '../../../utils/convertColours';
import Container from './Container';
import styles from './Layout.module.css';
var cx = classNames.bind(styles);
export default function Rows(_a) {
    var gutterHeight = _a.gutterHeight, heightAsGutterMultiple = _a.heightAsGutterMultiple, fillColor = _a.fillColor, strokeColor = _a.strokeColor, count = _a.count;
    var top = 0;
    var rows = [];
    var colorStyle = fillColor
        ? { backgroundColor: rgbaArray2rgba(fillColor) }
        : { borderColor: rgbaArray2rgba(strokeColor) };
    for (var i = 0; i < count; i += 1) {
        var height = heightAsGutterMultiple * gutterHeight;
        rows.push(React.createElement("div", { className: cx('overlay', 'row', { strokeRow: strokeColor }), key: i, style: __assign({ left: 0, top: top, height: height }, colorStyle) }));
        top += height + gutterHeight;
    }
    return React.createElement(Container, null, rows);
}
Rows.propTypes = {
    gutterHeight: PropTypes.number.isRequired,
    heightAsGutterMultiple: PropTypes.number.isRequired,
    fillColor: PropTypes.arrayOf(PropTypes.number),
    strokeColor: PropTypes.arrayOf(PropTypes.number),
    count: PropTypes.number.isRequired,
};
